import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'

export const Landing = () => {
  return (
    <section className={`${pageXPadding} ${pageYPadding} `}>
      <div
        className={`${pageMaxWidth} mx-auto flex flex-col gap-y-[16px] md:flex-row md:gap-x-[31px]  `}
      >
        <div className="flex flex-col gap-y-[12px] md:gap-y-[24px]">
          <div className="flex justify-center md:justify-start">
            <SectionTitle title="About us" />
          </div>
          <p className="text-center font-nunito text-[16px] font-bold leading-[19.2px] text-[#333333] md:text-start md:text-[24px] md:leading-[28.8px] ">
            Crafting Spaces with Vision and Precision
          </p>
          <p className="text-center font-nunito text-[12px] font-normal leading-[19.2px] text-[#333333] md:text-start md:text-[16px] md:leading-[25.6px]  ">
            {`We believe that exceptional design begins with a vision and is realized through meticulous attention to detail. Our passion for creating stunning, functional spaces drives us to deliver designs that not only meet but exceed our clients' expectations.`}
          </p>
        </div>
        <div className="flex flex-col gap-y-[12px] md:gap-y-[24px]">
          <div className="flex justify-center md:justify-start">
            <SectionTitle title="Who We Are" />
          </div>
          <p className="text-center font-nunito text-[12px] font-normal leading-[19.2px]  text-[#333333] md:text-start md:text-[16px] md:leading-[25.6px]">
            <p>
              {`Founded in 2017, RR Interiors has been dedicated to transforming interiors into masterpieces. With a team of talented designers and architects, we bring a wealth of experience and a fresh perspective to every project. Our mission is to create environments that inspire and elevate the everyday experiences of our clients.`}
            </p>
            <p>
              {`Our design philosophy revolves around blending aesthetics with functionality. We work closely with our clients to understand their unique needs and preferences, ensuring every project reflects their personality and lifestyle.`}
            </p>
          </p>
        </div>
      </div>
    </section>
  )
}
